import React from 'react';
import pt from 'prop-types';

import './partners.scss';

export default function ListingCriteria({ categories }) {
  return (
    <div className="partner-listing-criteria">
      {categories.map((category) => (
        <div key={category.key} className="partner-listing-criteria-category">
          <h4 className="partner-listing-criteria-category-title">
            {category.title}
          </h4>
          {category.items.length > 0 && (
            <ul className="partner-listing-criteria-category-items">
              {category.items.map((item) => (
                <li key={item.id}>{item.label}</li>
              ))}
            </ul>
          )}
        </div>
      ))}
    </div>
  );
}

ListingCriteria.propTypes = {
  categories: pt.arrayOf(
    pt.shape({
      key: pt.string.isRequired,
      title: pt.string.isRequired,
      items: pt.arrayOf(
        pt.shape({ id: pt.string.isRequired, label: pt.string.isRequired }),
      ).isRequired,
    }),
  ).isRequired,
};
